module.exports = "/_next/static/images/6f33a55a1addb52bd99018fad7606997-icon_card.png.webp";